import request from '@/utils/request'

export function register(data) {
  return request({
    url: '/register',
    method: 'post',
    data: data,
    timeout: 5000 // 增加超时时间
  })
}


export function emailLogin(data) {
  return request({
    url: '/email/login',
    method: 'post',
    data: data
  })
}

// export function login(data) {
//   return request({
//     url: '/login',  // 修正为后端接口路径
//     method: 'post',
//     data: {
//       username: data.email,  // 将email映射到后端需要的username字段
//       password: data.password,
//       // 如果后端需要验证码，添加以下字段（否则可删除）
//       code: '',
//       uuid: ''
//     }
//   })
// }



// WEBPACK FOOTER //
// ./src/api/user.js